import styles from '../home.module.scss'

export default function Credit() {
    const current = new Date();
    const date = `${current.getFullYear()}`;
    return (
        <div className={styles.credit}>
            <p><strong>Dreamvast</strong></p>
            <p>© {date} Copyright RainyService. All Rights Reserved.</p>
        </div>
    )
}